import { render } from "./UploadCSV.vue?vue&type=template&id=4f7cffea"
import script from "./UploadCSV.vue?vue&type=script&lang=js"
export * from "./UploadCSV.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__